import { NAVIGATION_TO_LANDING_PAGE } from '../../actions/page';
import { TOGGLE_TOOLTIP } from '../../actions/tooltip';

const initialState = {
  orderNumberTooltip: false,
  invalidProvinceErrorTooltip: false,
  loginErrorTooltip: false,
  step1ErrorTooltip: false,
  returnPostErrorTooltip: false,
  claimPostErrorTooltip: false,
  customContent: {},
};

export default (state = initialState, { type, data: { name, content } = {} } = {}) => {
  switch (type) {
    case TOGGLE_TOOLTIP:
      return {
        ...state,
        [name]: !state[name],
        customContent: {
          ...state.customContent,
          [name]: content,
        },
      };

    case NAVIGATION_TO_LANDING_PAGE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
